import axios from 'axios'
import { store } from './../store'
import { logout } from 'src/redux/reducer/commomReducer.js/commonReducer'
import { clearMessageStore } from 'src/redux/reducer/messageReducer.js/messageReducer'
import { clearSucideUserStore } from 'src/redux/reducer/sucideUserReducer.js/sucideUserReducer'

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
})

const requestHandler = (request) => {
  request.headers.Authorization = `Bearer ${store.getState().common.token}`
  return request
}

const responseHandler = (response) => {
  return response
}

axiosInstance.interceptors.request.use((request) => requestHandler(request))

axiosInstance.interceptors.response.use(
  (response) => responseHandler(response),
  (err) => {
    if (err.response && err.response.data) {
      if (err.response.data.message === 'Token invalid') {
        localStorage.clear()
        store.dispatch(clearMessageStore())
        store.dispatch(clearSucideUserStore())
        store.dispatch(logout())
      } else {
        throw Error(JSON.stringify(err.response))
      }
    }
    throw Error(err.message)
  },
)
